import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { PaymentTerm, type PaymentTermConstructor } from './PaymentTerm'

export const PaymentTermConstructorFactory =
  Factory.Sync.makeFactory<PaymentTermConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.lorem.word()),
    description: Factory.each(() => faker.lorem.sentence()),
    active: true,
  })

export const PaymentTermFactory = EntityFactory(
  PaymentTerm,
  PaymentTermConstructorFactory
)
